import React, {useState, useEffect} from 'react';

interface CountdownProps {
  startTime: number | undefined;
  endTime: number | undefined;
  className?: string;
}

export function Countdown({startTime, endTime}: CountdownProps) {
  const [text, setText] = useState('');

  useEffect(() => {
    if (!startTime && !endTime) {
      setText('');
      return;
    }
    const start = startTime ? new Date(startTime).getTime() : null;
    const end = endTime ? new Date(endTime).getTime() : null;

    const tick = () => {
      const now = Date.now();
      let target: number | null = null;
      if (start != null && end != null) {
        if (now < start) {
          target = start;
        } else if (now < end) {
          target = end;
        }
      } else if (start != null && now < start) {
        target = start;
      } else if (end != null && now < end) {
        target = end;
      }

      if (target == null) {
        setText('');
        return;
      }
      const diff = target - now;
      if (diff <= 0) {
        setText('');
        return;
      }
      const hours = Math.floor(diff / (1000 * 60 * 60));
      const minutes = Math.floor((diff % (1000 * 60 * 60)) / (1000 * 60));
      if (hours > 0) {
        setText(`${hours}h : ${minutes}m`);
      } else {
        const seconds = Math.floor((diff % (1000 * 60)) / 1000);
        setText(`${minutes}m : ${seconds}s`);
      }
    };

    tick();
    const timer = setInterval(tick, 1000);
    return () => clearInterval(timer);
  }, [startTime, endTime]);

  if (!text) {
    return null;
  }
  return <span className="text-[#FF2156] text-sm font-bold">{text}</span>;
}
